import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import {Provider as BusProvider} from "./useBus"
import App from './App';
import './index.css';
import { initWinNum,changeVideoAllScreen, setContainer } from "./features/layout/layoutSlice"
import http from "./http"

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

function VideoObj(id, winNum, ip , port , token , playMethod, onEventNotify, ak, initCameraData = []) {
    let baseUrl = ""
    if(ip.indexOf("http")  > -1 ){
      baseUrl = `${ip}:${port}`
    } else {
      baseUrl = `http://${ip}:${port}`
    }
    baseUrl = ip
    
    // 调试

    localStorage.setItem("token", token)

    console.log(baseUrl)
    http.axios.defaults.baseURL = baseUrl 
    const container = document.getElementById(id);
    this.store.dispatch(initWinNum(winNum))
    this.store.dispatch(setContainer(container))
    this.render(container)

    setTimeout(() => {
      playMethod(this)
    });


    if(initCameraData.length > 0){
      console.log("initCameraData1",initCameraData)
        console.log("initCameraData",initCameraData)
        initCameraData.map((item, index) => {
          (function (devdata) {
            console.log("播放",devdata)
            setTimeout(() => {
              window.bus.emit("play", devdata)
            }, 100 * (index + 1))
          })(item)
          
        })
    }
}

VideoObj.prototype.store = store

VideoObj.prototype.splitScreen = function(winNum) {
  setTimeout(() => {
    window.bus && window.bus.emit("changeScreen", winNum)
  }, 100);
}

VideoObj.prototype.fullScreen = function() {
  this.container.requestFullscreen()
  // store.dispatch(changeVideoAllScreen(true))
}


VideoObj.prototype.exitScreen = function() {
  document.exitFullscreen()
  // store.dispatch(changeVideoAllScreen(true))
}


VideoObj.prototype.render = function(container) {
  this.container = container
  const root = createRoot(container);
  root.render(
    <BusProvider>
      <Provider store={store}>
          <App />
      </Provider>
    </BusProvider>
  )
}

window.VideoObj = VideoObj



// let demo = new VideoObj(
//   'root',
//   1,
//   '/api',
//   '2888',
//   'eyJhbGciOiAiSFMyNTYiLCAidHlwIjogIkpXVCJ9.eyJ1c2VyIjoiYWRtaW4iLCJwZXJtaXQiOjI2ODYzMjk1OSwibGV2ZWwiOjAsImlzdCI6MTc1ODg5NTA0OH0.6UX-_3VvGzMTSMr_B_mJuHGFrAbNUeh7DBftNO3mmeY',
//   1,
//   'callback',
//   2,
//   [],
// );

// window.demo = demo



// setTimeout(() => {
//   window.bus.emit('play', {
//     status: 'ON',
//     kind: 'custom',
//     device: '11111111111333333334',
//     id: '11224455555555555555',
//     name: 'RTMP测试地址',
//   });

//   window.bus && window.bus.on("ptz", (data) => {
//     console.log("ptz ++++++++++++++?", data)
//   });
  
// }, 1000);



